export default "__VITE_ASSET__CUMwJJNW__"